<p class="certificate-headline">Certificate Holder linked to this certificate ({{ groupedRowsByHolder().length }})</p>
<albert-certificate-holder-entity-manager emptyMessage="No certificate holders assigned."
                                          searchTooltip="Search Certificate Holders"
                                          testId="certificate-holder"
                                          [groupedRows]="groupedRows()"
                                          [searchForm]="searchForm"
                                          [searchResultRows]="searchResultRows()"
>
  <ng-template let-row
               albertHolderDisplayActions
  >
    <span class="w-fit"
          pTooltip="Remove Certificate Holder"
          tooltipPosition="left"
    >
      <button iconOnly
              pButton
              severity="secondary"
              type="button"
              [disabled]="!canEdit()"
              [outlined]="true"
              (click)="onRemoveHolder(row.holderIndex)"
      >
        <i class="pi pi-times"></i>
      </button>
    </span>
  </ng-template>

  <ng-template let-row
               albertAddressDisplayActions
  >
    <button iconOnly
            pButton
            pTooltip="Remove Contact"
            severity="secondary"
            tooltipPosition="left"
            type="button"
            [outlined]="true"
            (click)="onRemoveAddress(row.holderIndex, row.addressIndex)"
    >
      <i class="pi pi-times"></i>
    </button>
  </ng-template>

  <ng-template let-row
               albertHolderSearchActions
  >
    <div class="flex gap-1">
      <button data-test="certificate-holder-add-without-emails"
              iconOnly
              pButton
              pTooltip="Add Certificate Holder"
              severity="secondary"
              tooltipPosition="left"
              type="button"
              [outlined]="true"
              (click)="onAddHolderWithoutEmails(searchResults()[row.holderIndex]!)"
      >
        <i class="pi pi-plus"></i>
      </button>
    </div>
  </ng-template>

  <ng-template let-row
               albertAddressSearchActions
  >
    <button iconOnly
            pButton
            pTooltip="Add Contact"
            severity="secondary"
            tooltipPosition="left"
            type="button"
            [outlined]="true"
            (click)="onAddSingleEmail(row.holderIndex, row.addressIndex)"
    >
      <i class="pi pi-plus"></i>
    </button>
  </ng-template>
</albert-certificate-holder-entity-manager>
